import { Tag } from '../../model/tagging/Tag';
import { Factory } from '../../services/Factory';

namespace app.controllers.batching {

  import Batch = app.model.batching.Batch;

  interface IAssignBatchScope extends angular.IScope {
    batch: Tag;
    batchClone: Tag;
    close: Function;
    assign: Function;
  }

  export class AssignBatchModalController {
    constructor($scope: IAssignBatchScope, $rootScope: IRootScope, $modalInstance: any, project: any, batch: Tag, batchService: app.services.batching.BatchService, notificationService: app.services.INotificationService) {
      $scope.batchClone = {...batch};

      $scope.close = () => {
        $modalInstance.close();
      };

      $scope.assign = async () => {
        $modalInstance.close();

        await batchService.Assign(project, new Batch(batch.id, $scope.batchClone.users || [], $scope.batchClone.roles || []));

        batch.users = $scope.batchClone.users;
        batch.roles = $scope.batchClone.roles;

      };
    }
  }

  frontendApp.controller("AssignBatchModalController", ["$scope", "$rootScope", "$uibModalInstance", "project", "batch", "BatchService", "NotificationService", Factory.Create(AssignBatchModalController)]);
}
